// Maps a binary download/preview failure to a simple, localized message.
// `error` is either the HTTP/Axios error dispatched by the saga or
// an Axios error an Axios error
// `t` is consuming component's localization translation
const getDownloadErrorMessage = (error, t) => {
  const status = error?.response?.status
  if (error?.code === 'CORRUPTED') {
    return t('downloadErrorCorrupted')
  }
  if (error?.code === 404 || status === 404) {
    return t('downloadNotFound')
  }
  if (status === 401 || status === 403) {
    return t('downloadErrorUnauthorized')
  }
  if (status === 502) {
    return t('downloadErrorGateway')
  }
  if (
    status === 504 ||
    status === 408 ||
    error?.code === 'ECONNABORTED' ||
    error?.code === 'ERR_NETWORK' ||
    error?.message?.toLowerCase().includes('timeout') ||
    !error?.response
  ) {
    return t('downloadErrorTimeout')
  }
  return t('downloadAttachmentError')
}

export default getDownloadErrorMessage
